import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IAddModulTipProgramPayload, IEditModulTipProgramPayload } from './module-tipuri-program.interface';
import { catchError, map, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ModuleTipuriProgramService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;
    private listModuleTipProgramURL =
        this.basePath +
        environment.interop.deps.nomenclatoare.moduleTipProgram.list;
    private listDTModuleTipProgramURL =
        this.basePath +
        environment.interop.deps.nomenclatoare.moduleTipProgram.listDT;
    private addModulTipProgramURL =
        this.basePath +
        environment.interop.deps.nomenclatoare.moduleTipProgram.store;
    private updateModulTipProgramURL =
        this.basePath +
        environment.interop.deps.nomenclatoare.moduleTipProgram.update;
    private deleteModulTipProgramURL =
        this.basePath +
        environment.interop.deps.nomenclatoare.moduleTipProgram.delete;

    constructor(private http: HttpClient) { }

    listModuleTipProgram() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.listModuleTipProgramURL
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id_program_type,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get module tip program:', error);
                    return throwError(error);
                })
            );
    }

    listDTModuleTipProgram() {
        return this.http.post(this.listDTModuleTipProgramURL, {});
    }

    addModulTipProgram(data: IAddModulTipProgramPayload) {
        return this.http.post(this.addModulTipProgramURL, data);
    }

    updateModulTipProgram(data: IEditModulTipProgramPayload) {
        return this.http.put(this.updateModulTipProgramURL, data);
    }

    deleteModulTipProgram(id: number) {
        return this.http.delete(this.deleteModulTipProgramURL + id);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
